import {useState} from "react";
import {css, cx} from "@panda/css";

import {ChevronDownIcon, ChevronUpIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IUserPoi} from "../types/IUserPoi";
import {SinglePoiForm} from "./SinglePoiForm";

interface IProps {
    offer: {
        geo_point: {
            coordinates: [number, number];
        };
    };
    hideHeader?: boolean;
    disableCollapsible?: boolean;
    className?: string;
    onChange?: (userPoi: IUserPoi) => void;
    onCheckTravelTime?: () => void;
}

export const SinglePoi = (props: IProps) => {
    const [collapsed, setCollapsed] = useState(false);

    const targetCoords = props.offer?.geo_point.coordinates;

    return (
        <div className={props.className}>
            {props.hideHeader ? null : (
                <div className={headingStyle}>
                    <Text as="span" variant="mini_header">
                        Moje miejsce
                    </Text>
                    {props.disableCollapsible ? null : (
                        <span className={toggleIconStyle} onClick={() => setCollapsed((prev) => !prev)}>
                            {collapsed ? <ChevronDownIcon size="2" /> : <ChevronUpIcon size="2" />}
                        </span>
                    )}
                </div>
            )}

            <div className={cx(collapsed && !props.disableCollapsible && hideStyle)}>
                <div className={userPoiFormStyle}>
                    <SinglePoiForm onChange={props.onChange} onCheckTravelTime={props.onCheckTravelTime} targetCoords={targetCoords} />
                </div>
            </div>
        </div>
    );
};

const headingStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    userSelect: "none",
    mb: 1
});

const toggleIconStyle = css({
    display: "none",

    md: {
        display: "block",
        cursor: "pointer"
    }
});

const hideStyle = css({
    height: 0,
    overflow: "hidden"
});

const userPoiFormStyle = css({
    pb: 4,
    mb: 3,

    md: {
        pb: 0,
        mb: 0
    }
});
import {useState} from "react";
import {css, cx} from "@panda/css";

import {ChevronDownIcon, ChevronUpIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IUserPoi} from "../types/IUserPoi";
import {SinglePoiForm} from "./SinglePoiForm";

interface IProps {
    offer: {
        geo_point: {
            coordinates: [number, number];
        };
    };
    hideHeader?: boolean;
    disableCollapsible?: boolean;
    className?: string;
    onChange?: (userPoi: IUserPoi) => void;
    onCheckTravelTime?: () => void;
}

export const SinglePoi = (props: IProps) => {
    const [collapsed, setCollapsed] = useState(false);

    const targetCoords = props.offer?.geo_point.coordinates;

    return (
        <div className={props.className}>
            {props.hideHeader ? null : (
                <div className={headingStyle}>
                    <Text as="span" variant="mini_header">
                        Moje miejsce
                    </Text>
                    {props.disableCollapsible ? null : (
                        <span className={toggleIconStyle} onClick={() => setCollapsed((prev) => !prev)}>
                            {collapsed ? <ChevronDownIcon size="2" /> : <ChevronUpIcon size="2" />}
                        </span>
                    )}
                </div>
            )}

            <div className={cx(collapsed && !props.disableCollapsible && hideStyle)}>
                <div className={userPoiFormStyle}>
                    <SinglePoiForm onChange={props.onChange} onCheckTravelTime={props.onCheckTravelTime} targetCoords={targetCoords} />
                </div>
            </div>
        </div>
    );
};

const headingStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    userSelect: "none",
    mb: 1
});

const toggleIconStyle = css({
    display: "none",

    md: {
        display: "block",
        cursor: "pointer"
    }
});

const hideStyle = css({
    height: 0,
    overflow: "hidden"
});

const userPoiFormStyle = css({
    pb: 4,
    mb: 3,

    md: {
        pb: 0,
        mb: 0
    }
});
